export default axiosInstance => {
  async function schedule({ jwt }) {
    return (
      await axiosInstance({
        method: "get",
        url: "/liff/schedule",
        headers: { jwt }
      })
    ).data;
  }

  async function make({ jwt, form, reservation }) {
    return (
      await axiosInstance({
        method: "post",
        url: "/liff/appointment",
        headers: { jwt },
        data: { form, reservation }
      })
    ).data;
  }

  async function query({ jwt }) {
    return (
      await axiosInstance({
        method: "get",
        url: "/liff/appointment",
        headers: { jwt }
      })
    ).data;
  }

  async function cancel({ jwt, appointment }) {
    return (
      await axiosInstance({
        method: "delete",
        url: "/liff/appointment",
        headers: { jwt },
        params: { appointment }
      })
    ).data;
  }

  return {
    schedule,
    make,
    query,
    cancel
  };
};
